import React from 'react';
import styled from '@emotion/styled/macro';

const CardStyled = styled.div({
    padding: '18px',
    background: '#fcfbff',
    border: '1px solid #e7e0f2',
    borderRadius: '28px',
    width: '100%',
    boxShadow: '0 12px 40px rgba(45, 28, 90, 0.06)',
    overflow: 'hidden',
    '@media (max-width: 600px)': {
        padding: '12px',
        borderRadius: '18px'
    }
});

const CardTitle = styled.div({
    padding: '8px 8px 8px 8px',
    marginBottom: '16px',
    borderBottom: '1px solid #ebe5f4',
    width: '100%',
    fontSize: '22px',
    color: '#2c2150',
    fontWeight: 600
});

const Card = ({children, title = '', style}) => {
    return (
        <CardStyled style={style}>
            {title && <CardTitle className="card-title"> { title } </CardTitle>}
            {children}
        </CardStyled>
    );
};

export default Card; 